enum LocationSharingSettingsSorting {
  Team = 'Team',
  TeamMember = 'TeamMember',
  SettingValue = 'SettingValue',
}

export default LocationSharingSettingsSorting;
